<ng-select
  [loading]="loading$ | async"
  [formControl]="control"
  [items]="(items$ | async) ?? []"
  bindLabel="name"
  [placeholder]="labelTranslateKey | translate"
  (search)="onSearch($event.term)"
  (change)="onChange($event)"
  (scrollToEnd)="onScrollToEnd()"
  (clear)="onClear()"
  (close)="onClose()"
>
</ng-select>

@if (control.invalid && control.touched) {
  <span class="ng-select-error">
    {{ 'FORMS.ERROR.FIELD_REQUIRED' | translate }}
  </span>
} @else if (hintTranslateKey) {
  <mat-hint [translate]="hintTranslateKey"></mat-hint>
}
